/**
 * desc 防止多次点击事件
 * v-click-debounce:500="handler"
 * author Sooooup
 */

import _debounce from 'lodash/debounce';
import _noop from 'lodash/noop';

/**
 * @desc 绑定一个事件
 * @param {Element} element dom 元素
 * @param {string} event 事件名
 * @param {Function} handler 处理函数
 */
export function on(element, event, handler) {
  if (element && event && handler) {
    element.addEventListener(event, handler, false);
  }
}

/**
 * @desc 解除绑一个事件
 * @param {Element} element dom 元素
 * @param {string} event 事件名
 * @param {function} handler 处理函数
 */
export function off(element, event, handler) {
  if (element && event) {
    element.removeEventListener(event, handler, false);
  }
}

export const _directive = {
  bind(el, binding, vnode) {
    let threshold = binding.arg || 500;
    let handler = binding.value || _noop;

    const clickHandler = _debounce(function() {
      handler.call(vnode, arguments);
    }, threshold);

    el.__vueClickDebounce__ = clickHandler;
    on(el, 'click', clickHandler);
  },
  inserted: function() {},
  update: function() {},
  componentUpdated: function() {},
  unbind(el) {
    off(el, 'click', el.__vueClickDebounce__);
    delete el.__vueClickDebounce__;
  }
};
